export function accordion() {
    $(document).on("click", ".accounts-list .item button, .accordion-item a,.accordion-item button", function () {
        let $this = $(this);
        let parent = $this.parents(".accordion-item, .item");
        if (!parent.hasClass("active")) {
            parent.siblings().find("button").attr("aria-expanded", false);
            parent.siblings().removeClass("active").find(".hidden-info, .info, .description-holder").slideUp(300).attr("hidden",'');
            $this.attr("aria-expanded", true);
            parent.addClass("active").find(".hidden-info, .info, .description-holder").slideDown(300).removeAttr("hidden");
        } else {
            parent.removeClass("active").find(".hidden-info, .info, .description-holder").slideUp(300).attr("hidden",'');
            $this.attr("aria-expanded", false);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js